// removed by extract-text-webpack-plugin
module.exports = {"check":"_2m0rBDZknF"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scripts/components/forms/secure/PayNowForm/BankInfoFields/BankInfoFields.module.less
// module id = 988
// module chunks = 3